/* Shared Precise header: native links, accessible menus and Shopify search. */
(function () {
  'use strict';
  if (window.__ppNavigationLoaded) return;
  window.__ppNavigationLoaded = true;
  function init() {
    document.querySelectorAll('.pp-home').forEach(function (root) {
      var nav = root.querySelector('.pp-nav');
      if (!nav || nav.__ppNavigationWired || root.hasAttribute('data-zen-embed')) return;
      nav.__ppNavigationWired = true;
      var listeners = [];
      function on(target, type, handler) {
        if (!target) return;
        target.addEventListener(type, handler);
        listeners.push(function () { target.removeEventListener(type, handler); });
      }
      var trigger = nav.querySelector('[data-pp-mega-trigger]');
      var mega = nav.querySelector('[data-pp-mega]');
      var hoverOnly = false;
      var leaveTimer;
      function megaOpen() { return nav.classList.contains('is-mega-open'); }
      function setMega(open, hover) {
        clearTimeout(leaveTimer);
        if (!trigger || !mega) return;
        nav.classList.toggle('is-mega-open', open);
        trigger.setAttribute('aria-expanded', String(open));
        mega.hidden = !open;
        hoverOnly = open && !!hover;
        if (open) nav.style.setProperty('--pp-menu-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
      }
      setMega(false);
      on(trigger, 'mouseenter', function () {
        if (!window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          if (!megaOpen()) setMega(true, true);
        }
      });
      on(trigger, 'click', function (event) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        setMega(hoverOnly || !megaOpen());
      });
      on(trigger, 'keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== ' ') return;
        event.preventDefault();
        setMega(true);
        var first = mega.querySelector('a[href], button');
        if (first) first.focus();
      });
      on(nav, 'mouseenter', function () { clearTimeout(leaveTimer); });
      on(nav, 'mouseleave', function () { leaveTimer = setTimeout(function () { setMega(false); }, 150); });
      on(nav, 'focusout', function (event) { if (!nav.contains(event.relatedTarget)) setMega(false); });
      nav.querySelectorAll('[data-pp-mega-close]').forEach(function (link) {
        on(link, 'mouseenter', function () { setMega(false); });
        on(link, 'focus', function () { setMega(false); });
      });
      on(mega, 'click', function (event) { if (event.target.closest('a[href]')) setMega(false); });
      on(document, 'click', function (event) { if (megaOpen() && !nav.contains(event.target)) setMega(false); });
      var burger = root.querySelector('[data-pp-mobile-open]');
      var mobile = root.querySelector('[data-pp-mobile]');
      var prevOverflow = '';
      function mobileOpen() { return !!mobile && mobile.classList.contains('is-open'); }
      function setMobile(open, restoreFocus) {
        if (!burger || !mobile || open === mobileOpen()) return;
        mobile.classList.toggle('is-open', open);
        mobile.hidden = !open;
        burger.setAttribute('aria-expanded', String(open));
        if (open) {
          setMega(false);
          prevOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          var first = mobile.querySelector('[data-pp-mobile-close], button, a[href]');
          if (typeof trapFocus === 'function') trapFocus(mobile, first);
          else if (first) first.focus();
        } else {
          document.documentElement.style.overflow = prevOverflow;
          if (typeof removeTrapFocus === 'function') removeTrapFocus(restoreFocus ? burger : null);
          else if (restoreFocus) burger.focus();
        }
      }
      on(burger, 'click', function () { setMobile(!mobileOpen(), true); });
      if (mobile) {
        mobile.hidden = true;
        on(mobile.querySelector('[data-pp-mobile-close]'), 'click', function () { setMobile(false, true); });
        mobile.querySelectorAll('a:not(.pp-mobile-search)').forEach(function (link) {
          on(link, 'click', function () { setMobile(false); });
        });
      }
      var modal = root.querySelector('.pp-search-modal-mount details-modal');
      root.querySelectorAll('.pp-nav-search, .pp-mobile-search').forEach(function (launcher) {
        on(launcher, 'click', function (event) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !modal || typeof modal.open !== 'function') return;
          event.preventDefault();
          event.stopPropagation();
          setMega(false);
          var returnFocus = launcher.classList.contains('pp-mobile-search') ? burger : launcher;
          setMobile(false);
          modal.open(event, returnFocus);
        });
      });
      on(document, 'keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (mobileOpen()) { event.preventDefault(); setMobile(false, true); }
        else if (megaOpen()) { event.preventDefault(); setMega(false); trigger.focus(); }
      });
      on(window, 'resize', function () {
        if (window.innerWidth > 1080) setMobile(false, true);
        else setMega(false);
        if (megaOpen()) nav.style.setProperty('--pp-menu-top', Math.max(0, nav.getBoundingClientRect().bottom) + 'px');
      });
      on(document, 'shopify:section:unload', function (event) {
        if (!event.target.contains(nav)) return;
        setMobile(false);
        if (modal && typeof modal.close === 'function' && modal.isOpen()) modal.close(false);
        clearTimeout(leaveTimer);
        listeners.forEach(function (remove) { remove(); });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
